import { IDependentValues } from '../../../@types/workspaceTypes';
import { Link, makeStyles, mergeClasses } from '@fluentui/react-components';
import React, { memo, ReactElement } from 'react';
import FormModal from '../FormModal';

//Type for implementing components (Wrappers around this formatter).
export type IFormModalFormatterProps<RowDataType = any> = {
  value: number | string;
  dependentValues: IDependentValues<RowDataType>;
};

const useStyles = makeStyles({
  link: {
    color: '#3949ab',
    width: '100%',
  },
});

const FormModalFormatter = memo(
  ({
    children,
    value,
    modalOpen,
    setModalOpen,
    onClick,
    hasModalTarget = true,
    className,
  }: {
    children: ReactElement;
    value: number | string | ReactElement;
    modalOpen: boolean;
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    onClick?: () => void;
    hasModalTarget?: boolean;
    className?: string;
  }) => {
    const styles = useStyles();

    return (
      <>
        {hasModalTarget ? (
          <Link
            className={mergeClasses(styles.link, className)}
            onClick={
              onClick
                ? onClick
                : (e) => {
                    // Prevent default row click behaviour occurring when we've specifically clicked the link.
                    e.stopPropagation();
                    setModalOpen(true);
                  }
            }
          >
            {value}
          </Link>
        ) : (
          <div className={className}>{value}</div>
        )}
        <FormModal modalOpen={modalOpen} setModalOpen={setModalOpen}>
          <div style={{ height: '90vh', width: '80vw', position: 'relative' }}>{modalOpen ? children : null}</div>
        </FormModal>
      </>
    );
  }
);

export default FormModalFormatter;
